import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "float-comparator"
    }}>{`Float comparator`}</h1>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/lib/internal/Magento/Framework/Math/FloatComparator.php"
      }}><inlineCode parentName="a">{`Magento\\Framework\\Math\\FloatComparator`}</inlineCode></a>{` library provides methods to compare float values with an approriate epsilon value (`}<inlineCode parentName="p">{`0.00001`}</inlineCode>{`). Floats usually have rounding errors while doing mathematical operations, so the conventional way of comparing two floats using the equality operator (`}<inlineCode parentName="p">{`==`}</inlineCode>{`), may not always lead to expected results. For more information, please refer to this `}<a parentName="p" {...{
        "href": "https://floating-point-gui.de/errors/comparison/"
      }}>{`article`}</a>{`.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Method`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`equal`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compares two given floats and returns a boolean value describing if they're equal.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`greaterThan`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compares two given floats and returns a boolean value describing if the first float is greater than the second float.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`greaterThanOrEqual`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Compares two given floats and returns a boolean value describing if the first float is greater than or equal to the second float.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`In the examples below, the `}<inlineCode parentName="p">{`$this->floatComparator`}</inlineCode>{` property is an instantiated object of the `}<inlineCode parentName="p">{`Magento\\Framework\\Math\\FloatComparator`}</inlineCode>{` class.`}</p>
    <h3 {...{
      "id": "check-if-two-floats-are-equal"
    }}>{`Check if two floats are equal`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$isEqual = $this->floatComparator->equal(1.002, 1.002);
`}</code></pre>
    <h3 {...{
      "id": "checks-if-the-first-float-is-greater-than-the-second-float"
    }}>{`Checks if the first float is greater than the second float`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$isGreater = $this->floatComparator->greaterThan(1.0004, 1.002);
`}</code></pre>
    <h3 {...{
      "id": "checks-if-the-first-float-is-greater-than-or-equal-to-the-second-float"
    }}>{`Checks if the first float is greater than or equal to the second float`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$isGreaterOrEqual = $this->floatComparator->greaterThanOrEqual(1.0004, 1.0004);
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      